import {deserializeAs} from 'cerialize';
import {Consommation} from './consommation';


export class ConsommationList {

  @deserializeAs(Consommation, 'consommations')
  consommations: Consommation[];
}
